import jsonata from "jsonata";
import { useEffect, useMemo } from "react";
import { FormGroup, Label, Input } from "reactstrap";
import { concatenatePaths, getObject, mapObject } from "../../util/mapObject";
import { useSideChannelSubscription } from "../../util/useSideChannel";
import applyFormatting, { useAppliedFormatter } from "../../util/applyFormatting";
import { useJnx } from "../../util/jnx";
import useOptionsLookup from "./hooks/useOptionsLookup";
import { useOpenModal } from "../FormModal";
import getPathFromId from "../../util/getPathFromId";


function ComputedField(props) {
    const {
        formContext,
        formContext: {
            openModal,
        },
        name,
        schema,
        onChange,
        idSchema: { $id },
        formData: formDataFieldValue,
        uiSchema: {
        'ui:onChange': onChangeExpr // <-- add ui:onChange
        },
    } = props;

    const {
        title,
        references,
        format,
        jsonata: jsonataComputation,
        computation,
        scope: schemaScope = '',
        onUpdate,
        lookup,
        hidden
    } = schema;

    const {
        sideChannel,
        bindings: fcBindings,
        setFormDataValues,
    } = formContext;

    const [rootFormData, formObject] = useSideChannelSubscription(sideChannel, [0, 1]) || [{}, {}];

    const {
        options: lookupOptions,
        loadingOptions,
        errorLoadingOptions
    } = useOptionsLookup({
        lookup,
        rootFormData,
    });

    const bindings = useMemo(() => ({
        ...fcBindings,
        formObject,
        formContext
    }), [fcBindings, formObject, formContext]);

    const path = useMemo(() => getPathFromId($id), [$id]);

    const jnxOnChange = useJnx(onChangeExpr, (_, onChangeJnx) => {
        if (onChangeJnx) onChangeJnx.evalAsync(rootFormData, path, {
            openModal
        }).then(result => {
            console.log("onChangeJnx result:", result);
        });
    }, [openModal, path, rootFormData]);

    const valueJnx = useJnx(jsonataComputation);
    const functionBinds = useMemo(() => ({
        set: setFormDataValues,
        log: (...args) => console.log("jsonata console log\n", ...args)
    }), [setFormDataValues]);
    const onUpdateJnx = useJnx(onUpdate, { functionBinds });

    useEffect(() => {
        if (valueJnx) {
            try {
                const refValue = valueJnx.eval({ ...rootFormData, lookupOptions }, path, bindings);
                if (refValue !== formDataFieldValue) {
                    // console.log(`Update ComputedField ${name} to ${refValue}`);
                    onChange(refValue);
                    if (jnxOnChange) jnxOnChange(); 
                    if (onUpdateJnx) setTimeout(() => {
                        onUpdateJnx.evalAsync(rootFormData, path, { ...bindings, value: refValue });
                    }, 100);
                }
            } catch (e) {
                console.log("Computed Field error");
                console.error(e);
            }
        }
    }, [valueJnx, rootFormData, path, formDataFieldValue, lookupOptions]);

    const text = useAppliedFormatter(formDataFieldValue, format);

    return hidden ? null : (<FormGroup disabled>
        {title !== " " ? <label className="control-label" htmlFor="root_preferredBranchId">
            {title}
        </label> : null}
        <Input
            disabled
            data-cy={$id}
            type="text"
            className="custom"
            value={text || ""}
            readOnly
        />
    </FormGroup>);
}


export default ComputedField;